import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';

const CATEGORY_ICONS = {
    BUDGET: 'fa-dollar-sign',
    CONFIGURATION: 'fa-cog',
    ACCOUNTS: 'fa-link',
    TEAM: 'fa-users',
    ALERTS: 'fa-bell',
    INTEGRATIONS: 'fa-plug',
    REPORTS: 'fa-file-alt',
    COMMENT: 'fa-comment',
    STATUS: 'fa-toggle-on',
    AGENT: 'fa-robot',
};

export function ActivityLogEntry({entry, clientId}) {
    const {t, i18n} = useTranslation();
    const [expanded, setExpanded] = useState(false);

    const icon = CATEGORY_ICONS[entry.category] || 'fa-circle';
    const categoryClass = entry.category ? entry.category.toLowerCase() : '';
    const hasDetail = entry.detail && Object.keys(entry.detail).length > 0;
    const hasComment = !!entry.comment_text;

    const createdOn = new Date(entry.created_on);
    const dateStr = createdOn.toLocaleDateString(i18n.language);
    const timeStr = createdOn.toLocaleTimeString(i18n.language, {hour: '2-digit', minute: '2-digit'});

    return (
        <div className="activity-log-entry">
            <div className={`entry-icon -${categoryClass}`}>
                <i className={`fas ${icon}`}/>
            </div>

            <div className="entry-content">
                <div className="entry-header">
                    <div>
                        <span className="entry-description">{entry.description}</span>
                        {entry.business_unit && (
                            <span className="entry-bu-tag">
                                {entry.business_unit.name}
                            </span>
                        )}
                    </div>
                    <span className="entry-timestamp">
                        {dateStr} {timeStr}
                    </span>
                </div>

                <div className="entry-meta">
                    <span className={`entry-category-badge -${categoryClass}`}>
                        {t('activity_log.category_' + entry.category.toLowerCase())}
                    </span>
                    {entry.performed_by && (
                        <span>
                            {t('activity_log.by')} {entry.performed_by.full_name}
                        </span>
                    )}
                    {entry.category === 'AGENT' && entry.detail && entry.detail.session_id && clientId && (
                        <Link to={`/client/${clientId}/agent/${entry.detail.session_id}`} className="entry-session-link">
                            {t('activity_log.open_agent_session')}
                        </Link>
                    )}
                </div>

                {hasComment && (
                    <div className={`entry-comment -${categoryClass}`}
                         dangerouslySetInnerHTML={{__html: entry.comment_text}}/>
                )}

                {hasDetail && (
                    <div className="entry-detail-toggle">
                        <button onClick={() => setExpanded(!expanded)}>
                            {expanded ? t('activity_log.hide_detail') : t('activity_log.show_detail')}
                        </button>
                        {expanded && (
                            <div className="entry-detail-content">
                                {JSON.stringify(entry.detail, null, 2)}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
